

export class AlertSpecificationStatusInput implements IAlertSpecificationStatusInput {
    /** The auto-generated id of the alert specification master */
    alertSpecificationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IAlertSpecificationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertSpecificationId = _data["alertSpecificationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertSpecificationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertSpecificationId"] = this.alertSpecificationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertSpecificationStatusInput {
    /** The auto-generated id of the alert specification master */
    alertSpecificationId: number;
    /** The updated status */
    status: number;
}

